import React from 'react';
import PropTypes from 'prop-types';

import Dropzone from 'react-dropzone';
import { Loader, Dimmer } from 'semantic-ui-react';

import errorHandler from './errors';

import './CommonDropzone.css';

const CommonDropzone = props => {

  const {
    multiple,
    maxFiles,
    maxSize,
    accept,
    className,
    children,
    noDrag,
    loading,
    onDrop,
    onError,
  } = props;

  const handleErrors = errors => {
    if (errors && errors.length > 0) {
      onError(errorHandler(errors, maxSize, maxFiles));
    }
  };

  return (
    <Dropzone
      {...props}
      onDrop={onDrop}
      multiple={multiple}
      maxFiles={maxFiles}
      maxSize={maxSize}
      accept={accept}
      noDrag={noDrag}
      onDropRejected={handleErrors}
    >
      {({ getRootProps, getInputProps }) => (
        <section className={`common-dropzone__component ${className}`}>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            {children}
            {loading &&
              <Dimmer active={loading}>
                <Loader />
              </Dimmer>
            }
          </div>
        </section>
      )}
    </Dropzone>
  );
};

CommonDropzone.propTypes = {
  multiple: PropTypes.bool,
  maxFiles: PropTypes.number,
  maxSize: PropTypes.number,
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf([PropTypes.string])]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.element, PropTypes.string]),
  noDrag: PropTypes.bool,
  loading: PropTypes.bool,
  onDrop: PropTypes.func.isRequired,
  onError: PropTypes.func,
};
CommonDropzone.defaultProps = {
  multiple: false,
  maxFiles: 1, // pass 0 which means there is no limitation to how many files are accepted
  maxSize: 6291456, // size in bytes is about 6mb
  accept: 'image/jpeg, image/png, image/gif', 
  className: '',
  children: null,
  noDrag: false,
  loading: false,
  onError: null,
};

export default CommonDropzone;
